import { twMerge } from "tailwind-merge";

import { CancelSubmitButtons } from "~/common/components";
import Modal from "~/common/components/Modal";

interface ReimbursementReportConfirmationModalProps {
  isPending: boolean;
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const ReimbursementReportConfirmationModal = ({
  isPending,
  show,
  onClose,
  onSubmit,
}: ReimbursementReportConfirmationModalProps) => (
  <Modal
    show={show}
    title="Complete progress note"
    description="Are you sure you want to complete the progress note? Once completed, you won't be able to make further changes."
    onClose={onClose}
  >
    <CancelSubmitButtons
      cancelClassName="w-fit"
      submitClassName={twMerge("w-fit", isPending && "w-60 justify-center")}
      containerClassName="w-fit self-end"
      submitButtonLabel="Complete progress note"
      submitButtonType="button"
      handleCancel={onClose}
      isSubmitting={isPending}
      handleSubmit={onSubmit}
    />
  </Modal>
);
